import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
export default [{
  path: '/badges/index/:userId?',
  name: ROUTE_NAME.BADGE,
  meta: {
    title: '我的成就'
  },
  component: function component() {
    return import(
    /* webpackChunkName: "medal" */
    './pages/index.vue');
  }
}, {
  path: '/badges/details/:medalId/:userId?',
  name: ROUTE_NAME.BADGE_DETAILS,
  meta: {
    title: '我的勋章'
  },
  component: function component() {
    return import(
    /* webpackChunkName: "medal" */
    './pages/details.vue');
  }
}, {
  path: '/badges/card/:medalId/:userId?',
  name: ROUTE_NAME.BADGE_CARD,
  meta: {
    title: '我的勋章'
  },
  component: function component() {
    return import(
    /* webpackChunkName: "medal" */
    './pages/card.vue');
  }
}];